import * as React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import store from './store';
import { message } from 'antd';
import 'moment/locale/zh-cn';
// import { ErrorBoundary } from 'react-error-boundary';

message.config({
  top: 100,
  duration: 2,
  maxCount: 1
});
message.destroy();

window.onerror = function (event: any, source: any, lineno: any, colno: any, error: any) {
  console.log({
    event,
    source,
    lineno,
    colno,
    error
  });
  if ((window as any).raw) {
    (window as any).raw.catchJsError({
      errorInfo: JSON.stringify({
        name: 'window.onerror',
        event,
        source,
        lineno,
        colno,
        error
      })
    });
    // 由于目前不清楚`ResizeObserver loop limit exceeded`的具体原因，这里先记录不做错误界面提醒
    if (String(event) === 'ResizeObserver loop limit exceeded') {
      return;
    }
    // 此错误不影响界面，也没人没时间修复，暂时ignore
    if (String(event) === 'Uncaught Error: The display target does not exist') {
      return;
    }
    if (String(event) === `Uncaught TypeError: Cannot read properties of null (reading 'scrollTop')`) {
      return;
    }
    if (sessionStorage.getItem('isExpiration')) {
      return;
    }
    (window as any).raw.errorStaticPage && (window as any).raw.errorStaticPage({ type: 'error', target: 'main' });
  }
};

window.onunhandledrejection = (event: any) => {
  if ((window as any).raw) {
    (window as any).raw.catchJsError({
      errorInfo: JSON.stringify({
        name: 'window.onunhandledrejection',
        event
      })
    });
    // 登录前资源已经更新，此时没有进入到layout，无法捕获资源错误，在这里处理
    // if (window.location.pathname === '/home/homePage') {
    //   if (sessionStorage.getItem('isExpiration')) {
    //     return;
    //   }
    //   (window as any).raw.errorStaticPage && (window as any).raw.errorStaticPage({ type: 'error', target: 'main' });
    // }
    // (window as any).raw.errorStaticPage && (window as any).raw.errorStaticPage({ type: 'error', target: 'main' });
  }
};

window.addEventListener('offline', () => {
  if ((window as any).raw) {
    (window as any).raw.catchJsError({
      errorInfo: JSON.stringify({
        name: 'window.addEventListener.offline',
        error: 'network offline'
      })
    });
    (window as any).raw.errorStaticPage && (window as any).raw.errorStaticPage({ type: 'offline', target: 'main' });
  }
});

// const ErrorFallback = (event: any) => (
//   <div className="electron_layout">
//     <div>
//       <p>页面发生了错误，请重启</p>
//       {event.error.message && <span>Here's the error: {event.error.message}</span>}
//     </div>
//   </div>
// );

ReactDOM.render(
  <Provider store={store}>
    <ConfigProvider locale={zhCN}>
      {/* <ErrorBoundary
        FallbackComponent={ErrorFallback}
        onError={error => {
          console.log('23333432432', error);
          if ((window as any).raw) {
            (window as any).raw.catchJsError({
              errorInfo: JSON.stringify({
                error
              })
            });
          }
        }}
      > */}
      <App />
      {/* </ErrorBoundary> */}
    </ConfigProvider>
  </Provider>,
  document.getElementById('root')
);
